import React, { useState } from "react"
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  Col,
  Row,
  Table,
  UncontrolledCollapse,
} from "reactstrap"
import exportToExcel from "./exportToExcel"
import { useHistory } from "react-router-dom"

const NewSessionResults = ({
  type,
  statusResults,
  batchDetails,
  setLayout,
  setViewModal,
}) => {
  const history = useHistory()
  const [open, setOpen] = useState("")
  const toggle = id => {
    if (open === id) {
      setOpen()
    } else {
      setOpen(id)
    }
  }

  const handleExport = (data, filename) => {
    let exportData = data.map(item => ({
      HID: item.HID,
      "Req No": item.RequestID,
      "Last Status": item.LastStatus,
      "Current Status": item.Status,
      Date: item.Date,
    }))

    exportToExcel(exportData, filename)
  }

  const handletotalResultsExport = () => {
    let exportData = []

    statusResults.map(item => {
      exportData.push(...item.results)
    })

    exportData = exportData.map(item => ({
      HID: item.HID,
      "Req No": item.RequestID,
      "Last Status": item.LastStatus,
      "Current Status": item.Status,
      Date: item.Date,
    }))

    exportToExcel(exportData, "Total Status Results")
  }

  const backHandler = () => {
    if (type === "upload") {
      setLayout("upload")
    } else {
      setViewModal(false)
      history.push("/baladi-history")
    }
  }

  return (
    <div>
      <Row className="d-flex justify-content-center mb-5">
        <Col className="d-flex justify-content-start">
          <Button onClick={backHandler}>Back</Button>
        </Col>
        <Col className="d-flex justify-content-center">
          <h4>{batchDetails.CreatedAt}</h4>
          {/* <h4>{new Date().toLocaleString()}</h4> */}
        </Col>
        <Col className="d-flex justify-content-end">
          <Button onClick={handletotalResultsExport}>Export</Button>
        </Col>
      </Row>

      <div>
        <Accordion flush open={open} toggle={toggle}>
          {statusResults.map((result, i) => (
            <AccordionItem key={i}>
              <AccordionHeader targetId={i}>
                <Row style={{ width: "100%" }}>
                  <Col>
                    {result.name}: ({result.results.length})
                  </Col>
                  <Col className="d-flex justify-content-end">
                    <Button
                      size="sm"
                      onClick={() => handleExport(result.results, result.name)}
                    >
                      Export
                    </Button>
                  </Col>
                </Row>
              </AccordionHeader>

              <AccordionBody accordionId={i}>
                <Table className="text-center">
                  <thead>
                    <th>#</th>
                    <th>Req No</th>
                    <th>last status</th>
                    <th>current status</th>
                    <th>Date</th>
                  </thead>
                  <tbody>
                    {result.results.map((item, index) => (
                      <tr key={index}>
                        <td>{item.HID}</td>
                        <td>{item.RequestID}</td>
                        <td>{item.LastStatus}</td>
                        <td>{item.Status}</td>
                        <td>{item.Date}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </AccordionBody>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  )
}

export default NewSessionResults
